

// USED FOR MODEL PAGES
document.addEventListener('DOMContentLoaded', () => {
    const videoUrlsDiv = document.querySelector('#video-urls');

if (!videoUrlsDiv) {
    console.error('🚫 Video URLs container not found');
    return;
}

let videoUrls;
try {
    videoUrls = JSON.parse(videoUrlsDiv.getAttribute('data-urls').replace('?h=','/'));
    if (!Array.isArray(videoUrls)) {
        throw new Error('data-urls is not an array');
    }
    console.log('✅ Successfully parsed video URLs:', videoUrls);
} catch (error) {
    console.error('🚫 Error parsing video URLs:', error);
    return;
}

const winH = window.innerHeight;

const tryFetchWithEndpoints = async (url, index) => {

    const encodedUrl = encodeURIComponent(url);
    const videoId = url.split('/').pop().split('?')[0];
       

    // Array of endpoints to try
    const endpoints = [
        {
            url: `https://vimeo.com/api/oembed.json?url=${encodedUrl}&responsive=true&maxheight=${winH}`,
            name: 'Standard oEmbed'
        },
        {
            url: `https://vimeo.com/api/oembed.json?url=${encodedUrl}`,
            name: 'Simple oEmbed'
        },
        {
            url: `https://vimeo.com/api/v2/video/${videoId}/oembed.json`,
            name: 'V2 API'
        }
    ];

    console.log(`🎬 Starting video load attempts for index ${index}:`, {
        originalUrl: url,
        videoId: videoId,
        endpoints: endpoints.map(e => e.name),
        endpoints_url: endpoints.map(e => e.url)
    });

    for (const endpoint of endpoints) {
        try {
            console.log(`📡 Trying endpoint: ${endpoint.name}`);
            const response = await fetch(endpoint.url);
            
            if (!response.ok) {
                console.warn(`⚠️ ${endpoint.name} failed with status: ${response.status}`);
                continue;
            }

            const data = await response.json();
            
            if (!data || !data.html) {
                console.warn(`⚠️ ${endpoint.name} returned invalid data`);
                continue;
            }

            console.log(`✅ Successfully loaded video with ${endpoint.name}`);
            return data;
        } catch (error) {
            console.warn(`⚠️ Error with ${endpoint.name}:`, error);
        }
    }
    
    throw new Error('All endpoints failed');
};

videoUrls.forEach(async (url, index) => {
    if (!url) {
        console.error(`🚫 Empty URL found at index ${index}`);
        return;
    }

    const videoContainer = document.querySelector(`#video-inner-${index}`);
    if (!videoContainer) {
        console.error(`🚫 Container #video-inner-${index} not found`);
        return;
    }

    try {
        videoContainer.innerHTML = '<div class="loading">Loading video...</div>';
        
        const data = await tryFetchWithEndpoints(url, index);
        videoContainer.innerHTML = data.html;
        
        console.log(`✅ Video ${index} successfully loaded and embedded`);
    } catch (error) {
        console.error(`❌ Failed to load video ${index}:`, error);
        videoContainer.innerHTML = `
            <div class="error-message">
                Error loading video: ${error.message}
                <br>
                <small>URL: ${url}</small>
            </div>`;
    }
});
});

// USED FOR NEWS AND HOME
document.addEventListener('DOMContentLoaded', () => {
    const videoBlockDivs = document.querySelectorAll('.js-video-block')
    
    if (videoBlockDivs.length > 0){
        videoBlockDivs.forEach(i => {
            let id = i.getAttribute('data-id')
            let winH = window.innerHeight
            let url = i.getAttribute('data-url')
            let autoplay = JSON.parse(i.getAttribute('data-autoplay'))
            let autoplayParams = ''
            if(autoplay == true){
                autoplayParams = '&autoplay=1&loop=1&muted=true&controls=false&background=1'
            }
            fetch(`https://vimeo.com/api/oembed.json?url=${url}&responsive=true&maxheight=${winH}${autoplayParams}`)
            .then(response => response.json())
            .then(data => {
                if(data['html']){
                    document.querySelector(`#video-inner-${id}`).innerHTML = data['html']
                }
            })
        })
    }
})